import { WhatsNewList } from './Components/WhatsNewList/WhatsNewList';

export const WhatsNew = () => {
  return <WhatsNewList />;
};
